import React, { useState, useEffect, useContext, useRef } from "react";
import { StyleSheet, Text, View, Dimensions, Animated } from "react-native";
import CustomText from "../customFutureBrowserText/index";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../Utils/responsive";
import { withRouter } from "react-router-dom";
import { ActivityContext } from "../../Containers/Activities/index";
import { chunkify } from "../../Utils/chunkify";
import "./index.css";
import leftHandle from "../../assets/images/FutureModule/leftHandleDark.png";
import rightHandle from "../../assets/images/FutureModule/rightHandle.png";
import ModuleTop from "../Layout/Default/module-top";

export const WidthDimension = Dimensions.get("screen").width;
export const heightLeftHandle = hp("68%");
export const heightRightHandle = hp("46%");
export const widthLeftHandle = wp("20%");
export const widthRightHandle = wp("20%");

let isSafari = false;
var ua = navigator.userAgent.toLowerCase();
if (ua.indexOf("safari") != -1) {
  if (ua.indexOf("chrome") > -1) {
    isSafari = false;
  } else {
    isSafari = true;
  }
}

const Index = ({
  moduleObject,
  moduleIndex,
  setModuleIndex,
  selectAnswerHandler,
  question,
  history,
}) => {
  const [allValue, setAllValue] = useState(null);
  const [indexing, setIndexing] = useState(null);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [currentSet, setCurrentSet] = useState(0);
  const [hide, setHide] = useState(false);
  const leftHandleAnimation = useState(new Animated.Value(-300))[0];
  const rightHandleAnimation = useState(new Animated.Value(300))[0];
  const resultContext = useContext(ActivityContext);
  const firstHandle = useRef(null);
  const secondHandle = useRef(null);

  useEffect(() => {
    if (moduleObject.questions) {
      const chunkiElement = chunkify(moduleObject.questions, 2, true);

      setAllValue(chunkiElement);

      const totalLength = chunkiElement.map((elem) => ({
        length: elem.length,
      }));
      setIndexing(totalLength);
    }

    Animated.parallel([
      Animated.timing(leftHandleAnimation, {
        toValue: 0,
        duration: 1000,
        useNativeDriver: false,
      }),
      Animated.timing(rightHandleAnimation, {
        toValue: 0,
        duration: 1000,
        useNativeDriver: false,
      }),
    ]).start();
  }, []);

  const saveAnswer = (index) => {
    selectAnswerHandler(
      moduleObject.moduleid,
      allValue[currentSet][questionIndex].qid,
      allValue[currentSet][questionIndex].answers[index].respid
    );
  };

  const handleButtonClick = (val) => {
    if (val === "Left") {
      if (questionIndex < indexing[currentSet].length - 1) {
        saveAnswer(0);
        setQuestionIndex((prev) => prev + 1);
      } else {
        saveAnswer(0);
        setQuestionIndex(0);
        setCurrentSet((prev) => prev + 1);
      }
    } else {
      if (questionIndex < indexing[currentSet].length - 1) {
        for (let i = questionIndex; i < indexing[currentSet].length - 1; i++) {
          selectAnswerHandler(
            moduleObject.moduleid,
            allValue[currentSet][i].qid,
            allValue[currentSet][i].answers[1].respid
          );
        }
      }
      selectAnswerHandler(
        moduleObject.moduleid,
        allValue[currentSet][indexing[currentSet].length - 1].qid,
        allValue[currentSet][indexing[currentSet].length - 1].answers[1].respid
      );
      setCurrentSet((prev) => prev + 1);
      setQuestionIndex(0);
    }
  };

  const rotateLeftAnimation = leftHandleAnimation.interpolate({
    inputRange: [-300, 0],
    outputRange: ["-90deg", "0deg"],
  });

  const rotateRightAnimation = rightHandleAnimation.interpolate({
    inputRange: [0, 300],
    outputRange: ["0deg", "90deg"],
  });

  const LeftRotateAnimation = [
    { translateY: heightLeftHandle / 2 },
    { translateX: widthLeftHandle / 2 },
    { rotate: rotateLeftAnimation },
    { translateY: -heightLeftHandle / 2 },
    { translateX: -widthLeftHandle / 2 },
  ];

  const rightRotateAnimation = [
    { translateY: heightLeftHandle / 2 },
    { translateX: -widthLeftHandle / 2 },
    { rotate: rotateRightAnimation },
    { translateY: -heightLeftHandle / 2 },
    { translateX: widthLeftHandle / 2 },
  ];

  const HandleLeftClick = () => {
    setHide(true);
    if (currentSet !== 2 && moduleIndex < indexing[currentSet].length - 1) {
      firstHandle.current = setTimeout(() => {
        handleButtonClick("Right");
      }, 600);
    } else {
      handleButtonClick("Right");
    }
    Animated.sequence([
      Animated.timing(leftHandleAnimation, {
        toValue: -300,
        duration: 800,
        useNativeDriver: false,
      }),
      Animated.timing(leftHandleAnimation, {
        toValue: 0,
        duration: 800,
        useNativeDriver: false,
      }),
    ]).start(() => setHide(false));
    if (currentSet === 0) {
      Animated.sequence([
        Animated.timing(rightHandleAnimation, {
          toValue: 300,
          duration: 800,
          useNativeDriver: false,
        }),
        Animated.timing(rightHandleAnimation, {
          toValue: 0,
          duration: 800,
          useNativeDriver: false,
        }),
      ]).start(() => setHide(false));
    }
  };

  const handleRightClick = () => {
    setHide(true);
    if (currentSet !== 2 && moduleIndex < indexing[currentSet].length - 1) {
      secondHandle.current = setTimeout(() => {
        handleButtonClick("Left");
      }, 600);
    } else {
      handleButtonClick("Left");
    }
    Animated.sequence([
      Animated.timing(leftHandleAnimation, {
        toValue: -300,
        duration: 800,
        useNativeDriver: false,
      }),
      Animated.timing(leftHandleAnimation, {
        toValue: 0,
        duration: 800,
        useNativeDriver: false,
      }),
    ]).start(() => setHide(false));
  };

  useEffect(() => {
    if (currentSet === 2) {
      resultContext.setModuleCompletedAtTime(moduleObject.moduleid);
      history.push("/");
    }
  }, [currentSet]);

  return (
    <div className="container">
      <div className="topSpace">
        <ModuleTop module="pb" noAnimate={true} />
      </div>
      <div className="mainContainer">
        <div className="topContainer">
          <View style={styles.headingContainer}>
            <View style={styles.Line} />
            <Text style={styles.header}>I'd rather have...</Text>
            <View style={styles.Line2} />
          </View>
        </div>
        <div
          className={`handleContainer ${
            isSafari ? "handleContainerSafari" : ""
          }`}
        >
          <Animated.View
            style={[{ transform: LeftRotateAnimation }, styles.custom]}
          >
            <div
              className="leftText"
              onClick={() => {
                !hide && HandleLeftClick();
              }}
            >
              {allValue !== null && currentSet !== 2 && (
                <CustomText
                  data={moduleObject.questions[moduleIndex].answers[1].text}
                  text="First"
                />
              )}
            </div>

            <img
              src={leftHandle}
              alt="leftHandle"
              className={`leftHandle ${isSafari ? "leftHandleSafari" : ""}`}
            />
          </Animated.View>
          <Animated.View
            style={[{ transform: rightRotateAnimation }, styles.custom2]}
          >
            <div
              className="rightText"
              onClick={() => {
                !hide && handleRightClick();
              }}
            >
              {allValue !== null && currentSet !== 2 && (
                <CustomText
                  data={moduleObject.questions[moduleIndex].answers[0].text}
                  text="second"
                />
              )}
            </div>
            <img
              src={rightHandle}
              alt="rightHandle"
              className={`rightHandle  ${isSafari ? "rightHandleSafari" : ""}`}
            />
          </Animated.View>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Index);

const styles = StyleSheet.create({
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  topspace: {
    height: "15vh",
    width: "100vw",
  },
  content: {
    flex: 1,
    position: "relative",
    margin: "auto",
    display: "flex",
    width: "80vw",
    height: "85vh",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  headingContainer: {
    width: "100vw",
    height: "auto",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: hp("4%"),
    overflow: "visible",
  },
  borderTop: {
    position: "relative",
    backgroundColor: "var(--module-color-pb)",
    height: 3,
    alignSelf: "center",
    width: "100%",
    marginBottom: "6px",
  },
  logo: {
    width: "48px",
    height: "14px",
    resizeMode: "contain",
    alignSelf: "flex-end",
    marginRight: 7,
  },
  line: {
    position: "relative",
    width: "60%",
    minWidth: 183,
    height: 1,
    backgroundColor: "#d4d4d4",
    alignSelf: "center",
  },
  header: {
    position: "relative",
    width: "100%",
    height: "auto",
    alignSelf: "center",
    fontWeight: "var(--page-header-font-weight)",
    fontSize: "var(--page-header-font-size)",
    letterSpacing: "var(--page-header-letter-spacing)",
    marginTop: 7,
    textAlignVertical: "center",
    textAlign: "center",
    color: "var(--page-header-font-color)",
    textTransform: "var(--page-header-text-transform)",
  },
  custom: {
    overflow: "hidden",
    height: "80%",
    width: "50%",
  },
  custom2: {
    overflow: "hidden",
    height: "58%",
    width: "50%",
  },
});
